"use strict";

var _taggedTemplateLiteral = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _toConsumableArray = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var collection_1 = require("./collection");

function isAqlQuery(query) {
  return Boolean(query && typeof query.query === "string" && query.bindVars);
}

exports.isAqlQuery = isAqlQuery;

function isGeneratedAqlQuery(query) {
  return isAqlQuery(query) && typeof query._source === "function";
}

exports.isGeneratedAqlQuery = isGeneratedAqlQuery;

function isAqlLiteral(literal) {
  return Boolean(literal && typeof literal.toAQL === "function");
}

exports.isAqlLiteral = isAqlLiteral;

function aql(templateStrings) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var strings = _toConsumableArray(templateStrings);

  var bindVars = {};
  var bindVals = [];
  var query = strings[0];

  for (var i = 0; i < args.length; i++) {
    var rawValue = args[i];
    var value = rawValue;

    if (isGeneratedAqlQuery(rawValue)) {
      var src = rawValue._source();

      if (src.args.length) {
        query += src.strings[0];
        args.splice.apply(args, [i, 1].concat(_toConsumableArray(src.args)));
        strings.splice.apply(strings, [i, 2, strings[i] + src.strings[0]].concat(_toConsumableArray(src.strings.slice(1, src.args.length)), [src.strings[src.args.length] + strings[i + 1]]));
      } else {
        query += rawValue.query + strings[i + 1];
        args.splice(i, 1);
        strings.splice(i, 2, strings[i] + rawValue.query + strings[i + 1]);
      }

      i -= 1;
      continue;
    }

    if (rawValue === undefined) {
      query += strings[i + 1];
      continue;
    }

    if (isAqlLiteral(rawValue)) {
      query += "".concat(rawValue.toAQL()).concat(strings[i + 1]);
      continue;
    }

    var index = bindVals.indexOf(rawValue);
    var isKnown = index !== -1;
    var name = "value".concat(isKnown ? index : bindVals.length);

    if (collection_1.isArangoCollection(rawValue)) {
      name = "@".concat(name);
      value = rawValue.name;
    }

    if (!isKnown) {
      bindVals.push(rawValue);
      bindVars[name] = value;
    }

    query += "@".concat(name).concat(strings[i + 1]);
  }

  return {
    query: query,
    bindVars: bindVars,
    _source: function _source() {
      return {
        strings: strings,
        args: args
      };
    }
  };
}

exports.aql = aql;

(function (aql) {
  aql.literal = function (value) {
    if (isAqlLiteral(value)) {
      return value;
    }

    return {
      toAQL: function toAQL() {
        if (value === undefined) {
          return "";
        }

        return String(value);
      }
    };
  };

  aql.join = function (values) {
    var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";

    if (!values.length) {
      return aql(_templateObject());
    }

    if (values.length === 1) {
      return aql(_templateObject2(), values[0]);
    }

    return aql.apply(void 0, [[""].concat(_toConsumableArray(Array(values.length - 1).fill(sep)), [""])].concat(_toConsumableArray(values)));
  };
})(aql = exports.aql || (exports.aql = {}));